var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _rect, _rect2, _rect3, _rect4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSodiumWarning = function SvgSodiumWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 35,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.235 7.309c.753-1.412 2.777-1.412 3.53 0l12.666 23.75c.71 1.332-.255 2.941-1.764 2.941H2.333C.823 34-.142 32.391.57 31.059z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.772 21.316A1 1 0 0 1 13.721 20h2.558a1 1 0 0 1 .949 1.316l-.044.132a2 2 0 0 0-.043 1.117l1.238 4.95A2 2 0 0 1 16.439 30h-2.877a2 2 0 0 1-1.94-2.485l1.237-4.95a2 2 0 0 0-.043-1.117z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M16.5 24H14a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 0.5,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 0.5,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 15.5,
    r: 0.5,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 19a3 3 0 1 1 6 0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 11.5,
    y: 19.5,
    fill: "#fff",
    stroke: "#000",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3,
    x: 11.629,
    y: 14.681,
    fill: "#000",
    rx: 0.5,
    transform: "rotate(-15 11.629 14.68)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 14.5,
    y: 14.5,
    fill: "#000",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3,
    x: 17.405,
    y: 14.422,
    fill: "#000",
    rx: 0.5,
    transform: "rotate(15 17.405 14.422)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M27.318 31.142 15.66 9.689a.75.75 0 0 0-1.318 0L2.681 31.142a.75.75 0 0 0 .66 1.108h23.318a.75.75 0 0 0 .66-1.108Z"
  })));
};
export default SvgSodiumWarning;